import { useRef, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import {
  Container, Box, Typography, Grid, Button
} from '@mui/material';
import { useStyles } from './style';
import { Camera } from '../shared/Camera';
import { cameraImageAction } from '../../redux/camera/Reducer';

import { dateFormat } from '../../utils/dateFormat';
import { ageCalculation } from '../../utils/generalFunc';

export const CameraTake = () => {
  const classes = useStyles();
  const history = useHistory();
  const dispatch = useDispatch();
  const captureCamera = useRef();
  const [captureImageBase64, setCaptureImageBase64] = useState('');
  const [cameraType, setCameraType] = useState('start');
  const profile = useSelector((state) => state.profile.profilInfo);
  const BirthDate = dateFormat(profile.Birthday);
  const getAge = ageCalculation(profile.Birthday);

  const handleCapturePhoto = () => {
    const captureBase64Image = captureCamera.current.getScreenshot();
    setCaptureImageBase64(captureBase64Image);
    dispatch(cameraImageAction(captureBase64Image));
    setCameraType('stop');
  };

  const handleCaptureRetake = () => {
    setCameraType('start');
  };

  const takePhotoBackHandler = () => {
    history.push('/camera-view');
  };

  // eslint-disable-next-line consistent-return
  const cameraRenderWithImage = () => {
    if (cameraType === 'start') {
      return (
        <>
          <Box className={classes.cameraFaceBorder} />
          <Box className={classes.cameraOpenWrapper}>
            <Camera ref={captureCamera} />
          </Box>
        </>
      );
    }

    return (
      <Box className={classes.cameraTakeViewMainWrapper}>
        <Box className={classes.cameraTakeViewInsideWrapper}>
          <Box component="img" src={captureImageBase64} className={classes.cameraTakeView} />
        </Box>
      </Box>
    );
  };

  // eslint-disable-next-line consistent-return
  const cameraButtonChangeHandler = () => {
    if (cameraType === 'start') {
      return (
        <Grid container rowSpacing={{ xs: 3, sm: 2, md: 4 }}>
          <Grid item xs={12} md={6} className={classes.secondaryBtnWrapper}>
            <Box px={2}>
              <Button variant="contained" color="primary" onClick={handleCapturePhoto}>
                Take Photo
              </Button>
            </Box>
          </Grid>
          <Grid item xs={12} md={6} className={classes.primaryBtnWrapper}>
            <Box px={2}>
              <Button variant="contained" color="secondary" onClick={takePhotoBackHandler}>
                Back
              </Button>
            </Box>
          </Grid>
        </Grid>
      );
    }

    return (
      <Grid container rowSpacing={{ xs: 3, sm: 2, md: 4 }}>
        <Grid item xs={12} md={6} className={classes.secondaryBtnWrapper}>
          <Box px={2}>
            <Button onClick={() => history.push('/personal-info')} variant="contained" color="primary">
              Keep Photo
            </Button>
          </Box>
        </Grid>
        <Grid item xs={12} md={6} className={classes.primaryBtnWrapper}>
          <Box px={2}>
            <Button variant="contained" color="secondary" onClick={handleCaptureRetake}>
              Retake
            </Button>
          </Box>
        </Grid>
      </Grid>
    );
  };

  return (
    <Container maxWidth="md">
      <Box textAlign="center" pt={3} pb={1}>
        <Box component="span" fontSize={27}>
          {profile.First}
          <Box component="span" fontSize={27} fontWeight={500}> {profile.Last}</Box>
        </Box>
      </Box>
      <Box textAlign="center" pb={2}>
        <Box fontSize={18} fontWeight={500}>{BirthDate}</Box>
        <Box fontSize={14} fontWeight={500}>(Age {getAge})</Box>
      </Box>
      <Box className={classes.cameraMainConatiner}>
        <Box className={classes.cameraFrameContainer}>
          {cameraRenderWithImage()}
        </Box>
      </Box>
      <Box textAlign="center" py={2}>
        <Typography variant="body1">  Make sure your face fills the circle and you are against a simple backdrop. Remove any hats or facial coverings.</Typography>
      </Box>
      <Box className={classes.root}>
        {cameraButtonChangeHandler()}
      </Box>
    </Container>
  );
};
